<template>
  <div class="ic-card">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="120px" label-position="left">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>IC卡信息</i></p>
            <div class="totals-box pl24">
              <div class="flex-row mb30">
                <div class="itemName">转卡状态</div>
                <div class="itemNum jishi">{{ form.swivelClampStatusCn }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">账户状态</div>
                <div class="itemNum moneys">{{ form.statusCn }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">IC卡号</div>
                <div class="itemNum">{{ form.cardLogicNo }}</div>
              </div>
              <div class="flex-row mb30">
              <div class="itemName">登记姓名</div>
              <div class="itemNum">{{ form.username }}</div>
            </div>
            <div class="flex-row mb30">
                <div class="itemName">手机号码</div>
                <div class="itemNum">{{ form.userTel }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">卡内余额</div>
                <div class="itemNum moneys">￥{{ form.vipLogRestMoney }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">来源门店</div>
                <div class="itemNum">{{ form.machShopName }}</div>
              </div>
            </div>
            <div v-if="form.status == 'enable' && form.vipLogRestMoney > 0">
              <p class="order-title-boxs"><span class="blueBlock"></span><i>转电子会员卡</i></p>
              <el-row>
                <el-col :span="12">
                  <el-form-item class="el-form-item-update" label="会员姓名" v-show="!isMember">
                    <el-input v-model="parmar.memberName" maxlength="10" placeholder="请输入会员姓名" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="el-form-item-update" label="会员性别" v-show="!isMember">
                    <el-select v-model="parmar.gender" placeholder="请选择" class="w100b">
                      <el-option label="男" value="male"></el-option>
                      <el-option label="女" value="female"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="el-form-item-update" label="电话号码">
                    <el-input v-model="parmar.mobile" maxlength="11" placeholder="请输入电话号码" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="el-form-item-update" label="短信验证码">
                    <el-input v-model="parmar.verifyCode" maxlength="6" placeholder="请输入短信验证码">
                      <el-button slot="append" v-if="disabled" class="jishi">{{smsTitle}}</el-button>
                      <el-button slot="append" @click="changeMobile" v-if="!disabled" class="jishi">{{smsTitle}}</el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="el-form-item-update" label="设置密码" v-show="!isMember">
                    <el-input v-model="parmar.password" maxlength="6" type="password" placeholder="请输入设置密码" autocomplete="new-password" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="el-form-item-update" label="确认密码" v-show="!isMember">
                    <el-input v-model="parmar.confirmWord" maxlength="6" type="password" placeholder="请输入确认密码" autocomplete="new-password" />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
        <div class="space-between plr20 tip pb10">
          <div class="minw60">提示：</div>
          <div>
            <span>1. 转卡金额超过后台设置的审核金额或向同一个手机号转卡超过规定的次数时，转卡需要后台审核，审核通过后即转卡成功，转卡审核不通过将冻结IC卡</span><br />
            <span>2. 挂失或冻结的IC卡无法进行转卡操作</span>
          </div>
        </div>
        <div class="drawer-footer pr24 pb10">
          <div class="btns" v-if="form.status == 'enable' && form.vipLogRestMoney > 0">
            <el-button type="primary" class="small-btn" @click="turnCard">转卡</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "IC详情",
      addEditShow: false,
      form: { },
      parmar: {
        memberName: '',
        gender: 'male',
        mobile: '',
        verifyCode: '',
        password: '',
        confirmWord: ''
      },
      smsTitle: '发送验证码',
      time: 60,
      timeId: null,
      disabled: false,
      isMember: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        this.$api.get(this.$url.icCard.get, {
            id: org.id
          }).then(res => {
            if (res) {
              this.form = res;
            }
          });
      });
    },
    turnCard () {
      if (!this.isMember && !this.parmar.memberName) {
        return this.$message.error("请输入会员姓名")
      } else if (!this.parmar.mobile) {
        return this.$message.error("请输入电话号码")
      } else if (!/^1[3456789]\d{9}$/.test(this.parmar.mobile)) {
        return this.$message.error("请输入正确电话号码")
      } else if (!this.parmar.verifyCode) {
        return this.$message.error("请输入验证码")
      } else if (!this.isMember && !this.parmar.password) {
        return this.$message.error("请设置六位数的数字密码")
      } else if (!this.isMember && !this.parmar.confirmWord) {
        return this.$message.error("请设置六位数的数字确认密码")
      } else if (!this.isMember && this.parmar.confirmWord != this.parmar.password) {
        return this.$message.error("两次密码输入不一致")
      }
      this.parmar.id = this.form.id;
      this.$api.post(this.$url.icCard.turnCard, this.parmar).then( res => {
        if (res) {
          this.$message.success("转卡提交成功");
          setTimeout(() => {
            this.addEditShow = false;
            this.$emit("change", true);
          },1000)
        }
      }).catch(error => {})
    },
    changeMobile () {
      console.log(1);
      if (!this.parmar.mobile) {
        return this.$message.error("请输入电话号码")
      } else if (!/^1[3456789]\d{9}$/.test(this.parmar.mobile)) {
        return this.$message.error("请输入正确电话号码")
      }
      let parmar = encrypt(
        JSON.stringify({
          mobile: this.parmar.mobile,
          bizType: "turnCard"
        })
      )
      this.$api.post(this.$url.icCard.smsSends, parmar).then( res => {
        if (res) {
          this.disabled = true;
          let obj = JSON.parse(res);
          if (obj.isMember) {
             this.$confirm('该手机号已注册会员，请确定转卡', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false,
              type: 'warning',
              center: true
            }).then(() => {
              this.isMember = true;
              this.parmar.password = "";
              this.parmar.confirmWord = "";
              this.parmar.isMember = obj.isMember;
            }).catch(() => {});
          } else {
            this.isMember = false;
            this.$message.success("发送成功")
          }
          
          this.timeId = setInterval(() => {
            this.time--;
            this.smsTitle = this.time + '秒后重新获取';
            if (this.time <= 0) {
              this.disabled = false;
              this.time = 60;
              this.smsTitle = "发送验证码";
              clearInterval(this.timeId)
            }
          },1000)
        }
      }).catch(error => {})
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    }
  },
  destroyed () {
    clearInterval(this.timeId)
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;
}
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}
.tip {
  font-size: 14px;
  color: red;
}

.img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
}


</style>